import script from "./Window02Details.vue?vue&type=script&setup=true&lang=ts"
export * from "./Window02Details.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__